// src/utils/authStorage.js
// Resuelve en qué Storage vive la sesión según si el usuario marcó
// "Recordarme" al iniciar sesión: localStorage (persiste entre reinicios
// del navegador) o sessionStorage (se borra al cerrar la pestaña/navegador).
// El flag en sí siempre vive en localStorage — es lo único que sobrevive
// para que, en una pestaña nueva, sepamos dónde buscar el resto de la sesión.
const REMEMBER_FLAG = "auth_remember";

const KEYS = ["access_token", "refresh_token", "user_role", "user_name", "user_apellido"];

export function getAuthStorage() {
  return localStorage.getItem(REMEMBER_FLAG) === "0" ? sessionStorage : localStorage;
}

export function setRememberFlag(remember) {
  localStorage.setItem(REMEMBER_FLAG, remember ? "1" : "0");
}

export function clearAuthStorage() {
  for (const key of KEYS) {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  }
  localStorage.removeItem(REMEMBER_FLAG);
}
